// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__jyJmN","borderBlue":"styles_borderBlue__1Y-k4","borderWhite":"styles_borderWhite__Y10Pb"};